/* UserSelectionSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, xcss } from '@atlaskit/primitives';
import { Radio } from '@atlaskit/radio';
import TextField from '@atlaskit/textfield';
import { BodySmall, H6 } from '@atlassian/mpac-primitives';
import { memo, useCallback } from 'react';
import { TEST_IDS, USER_SELECTION_TEXT } from '../../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _10 = "._18u0xy5q{margin-left:var(--ds-space-400,2pc)}";
const _9 = "._1bsbmxpn{width:6rem}";
const _8 = "._4cvr1h6o{align-items:center}";
const _7 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _6 = "._1wyb1o8v{font-size:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _5 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _4 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const userSelectionContainer = xcss({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space.300'
});
const radioGroupContainer = xcss({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space.150'
});
const userInputContainer = null;
const radioLabelContainer = null;
const primaryText = null;
const secondaryText = null;
export const UserSelectionSection = /*#__PURE__*/memo(_ref => {
  let {
    selectedUserSelection,
    onUserSelectionChange,
    userCount,
    onUserCountChange
  } = _ref;
  const handleUserCountInputChange = useCallback(event => {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value >= 0) {
      onUserCountChange(value);
    } else if (event.target.value === '') {
      onUserCountChange(0);
    }
  }, [onUserCountChange]);
  const handleRadioChange = useCallback(value => {
    onUserSelectionChange(value);
  }, [onUserSelectionChange]);
  return /*#__PURE__*/_jsxs(Box, {
    xcss: userSelectionContainer,
    children: [/*#__PURE__*/_jsx(H6, {
      as: "h2",
      id: "user-selection-heading",
      children: USER_SELECTION_TEXT.HEADING
    }), /*#__PURE__*/_jsxs(Box, {
      xcss: radioGroupContainer,
      role: "radiogroup",
      "aria-labelledby": "user-selection-heading",
      testId: TEST_IDS.SELECT_QUANTITY_RADIO_GROUP,
      children: [/*#__PURE__*/_jsx(Radio, {
        value: "selectUsers",
        label: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _2, _3]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_4]
              }), /*#__PURE__*/_jsx(BodySmall, {
                className: ax(["_k48p1wq8"]),
                children: USER_SELECTION_TEXT.SELECT_USER_LABEL
              })]
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_5, _6]
              }), /*#__PURE__*/_jsx("div", {
                className: ax(["_syaz131l _1wyb1o8v"]),
                children: USER_SELECTION_TEXT.SELECT_USER_DESCRIPTION
              })]
            })]
          })]
        }),
        name: "userSelection",
        isChecked: selectedUserSelection === 'selectUsers',
        onChange: () => handleRadioChange('selectUsers'),
        testId: TEST_IDS.SELECT_QUANTITY_SELECT_USERS_RADIO_OPTION
      }), selectedUserSelection === 'selectUsers' && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_7, _2, _8, _9, _10]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_zulppxbi _1e0c1txw _4cvr1h6o _1bsbmxpn _18u0xy5q"]),
          children: /*#__PURE__*/_jsx(TextField, {
            type: "number",
            min: 1,
            value: userCount,
            onChange: handleUserCountInputChange,
            testId: TEST_IDS.SELECT_QUANTITY_USER_COUNT_INPUT,
            "aria-label": USER_SELECTION_TEXT.QUANTITY_INPUT_ARIA_LABEL
          })
        })]
      }), /*#__PURE__*/_jsx(Radio, {
        value: "selectAllUsers",
        label: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _2, _3]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_4]
              }), /*#__PURE__*/_jsx(BodySmall, {
                className: ax(["_k48p1wq8"]),
                children: USER_SELECTION_TEXT.ALL_USERS_LABEL
              })]
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_5, _6]
              }), /*#__PURE__*/_jsx("div", {
                className: ax(["_syaz131l _1wyb1o8v"]),
                children: USER_SELECTION_TEXT.ALL_USERS_DESCRIPTION
              })]
            })]
          })]
        }),
        name: "userSelection",
        isChecked: selectedUserSelection === 'selectAllUsers',
        onChange: () => handleRadioChange('selectAllUsers'),
        testId: TEST_IDS.SELECT_QUANTITY_SELECT_ALL_USERS_RADIO_OPTION
      })]
    })]
  });
});
UserSelectionSection.displayName = 'UserSelectionSection';